import { render, staticRenderFns } from "./Qualidade12.vue?vue&type=template&id=febbb9fc&scoped=true&"
import script from "./Qualidade12.vue?vue&type=script&lang=js&"
export * from "./Qualidade12.vue?vue&type=script&lang=js&"
import style0 from "./Qualidade12.vue?vue&type=style&index=0&id=febbb9fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febbb9fc",
  null
  
)

export default component.exports